import {Component, ElementRef, Input} from '@angular/core';
import {AnzahlProKategorie} from 'shared/dtos/cockpit-kontrolle/pruefung-der-variablen';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';

@Component({
  selector: 'app-effektive-ausbildung',
  templateUrl: './pruefung-der-variablen-effektive-ausbildung.component.html',
  styleUrls: [
    './pruefung-der-variablen-effektive-ausbildung.component.scss',
    '../../../cockpit-shared/contents/cockpit-styles.scss'
  ],
  standalone: false
})
export class PruefungDerVariablenEffektiveAusbildungComponent {
  @Input() data: AnzahlProKategorie[];
  @Input() downloadTxtKey: string;
  @Input() columnTxtKey: string;
  @Input() tableBottomTxtKey: string;
  @Input() filename: string;

  kategorien = ['8', '7', '6', '5', '4', '3', '2', '1'];

  constructor(
    private readonly tableDataExport: TableExportService,
    private readonly element: ElementRef
  ) {}

  getAnzahl(kategorie: number): number {
    if (this.data) {
      const result = this.data.find(
        item => item.Kategorie === kategorie.toString()
      );
      if (result) {
        return result.Anzahl;
      }
      return 0;
    }
    return null;
  }

  downloadTable() {
    this.tableDataExport.exportHtmlTableInElement(
      this.element.nativeElement,
      this.filename
    );
  }
}
